import * as React from "react";
function SvgCheckFat(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      ref={svgRef}
      {...props}
    >
      <path d="M3 7c-.27 0-.52-.11-.71-.29l-2-2A.996.996 0 111.7 3.3l1.29 1.29 3.3-3.3A.996.996 0 117.7 2.7L3.71 6.71A.99.99 0 013 7z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCheckFat);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
